import { Pipe, PipeTransform, ChangeDetectorRef, OnDestroy, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'dateAgo',
  pure: false,
  standalone: true
})
export class DateAgoPipe implements PipeTransform, OnDestroy {
  private translateService = inject(TranslateService);
  private cdr = inject(ChangeDetectorRef);

  private onLangChangeSub: Subscription;


  constructor() {
    this.onLangChangeSub = this.translateService.onLangChange.subscribe(event => {
      this.cdr.markForCheck();
    });
  }

  transform(value: any): any {
    if (!value || isNaN(new Date(value).getTime())) {
      return '';
    }

    const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
    if (seconds < 30) {
      return this.translateService.instant('DateAgo.JustNow');
    }

    const intervals: { [key: string]: number } = {
      'Year': 31536000,
      'Month': 2592000,
      'Week': 604800,
      'Day': 86400,
      'Hour': 3600,
      'Minute': 60,
      'Second': 1
    };

    for (const unit in intervals) {
      const counter = Math.floor(seconds / intervals[unit]);
      if (counter > 0) {
        return this.translateService.instant(`DateAgo.${unit}`, { count: counter });
      }
    }

    return '';
  }

  ngOnDestroy(): void {
    if (this.onLangChangeSub) {
      this.onLangChangeSub.unsubscribe();
    }
  }
}